"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

var style = (0, _core.makeStyles)(function () {
  return {
    paper: {
      marginTop: 10
    }
  };
});

var ThreeDotsMenu = function ThreeDotsMenu(props) {
  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      menuAnchorEl = _React$useState2[0],
      setMenuAnchorEl = _React$useState2[1];

  var classes = style();

  var commands = _react.default.Children.map(props.children, function (child, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      onClick: function onClick() {
        return setMenuAnchorEl(null);
      },
      children: child
    }, index);
  });

  var handleOpenMenu = function handleOpenMenu(event) {
    props.onOpen();
    setMenuAnchorEl(event.currentTarget);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: handleOpenMenu,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "menu",
        size: props.big ? 24 : null
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Menu, {
      className: classes.paper,
      anchorEl: menuAnchorEl,
      open: Boolean(menuAnchorEl),
      onClose: function onClose() {
        return setMenuAnchorEl(null);
      },
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      children: commands
    })]
  });
};

ThreeDotsMenu.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  big: _propTypes.default.bool,
  onOpen: _propTypes.default.func
};
ThreeDotsMenu.defaultProps = {
  big: false,
  onOpen: function onOpen() {}
};
var _default = ThreeDotsMenu;
exports.default = _default;
//# sourceMappingURL=ThreeDotsMenu.js.map